/* eslint-disable */
import { Box, useMatchBreakpoints, Text, Flex, Button, useModal } from '@noahswap/uikit'
import { useWeb3React } from '@noahswap/wagmi'
import styled from 'styled-components'
import Page from 'views/Page'
import { useActiveChainId } from 'hooks/useActiveChainId'
import NumericalInput from 'components/CurrencyInputPanel/NumericalInput'
import { DoubleCurrencyLogo } from 'views/Info/components/CurrencyLogo'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from '@noahswap/localization'
import LockModal from './components/LockModal'
import TransferModal from './components/TransferModal'
import { useGasPrice } from 'state/user/hooks'
import NextLink from 'next/link'
import { useTransactionAdder } from 'state/transactions/hooks'
import {
  useVotingEscrowContract,
  useEsnoahContract,
  useRewardsDistributorContract,
  useVesterContract,
  useVoterContract,
  useMinterContract,
} from 'hooks/useContract'
import { parseUnits } from '@ethersproject/units'
import { getBalanceAmount, formatBigNumberToFixed, formatFixedNumber, getRes, truncateZero } from 'utils/formatBalance'
import ResultModal from 'components/ResultModal'
import { transactionErrorToUserReadableMessage } from 'utils/transactionErrorToUserReadableMessage'
import BonusHelper from 'components/BonusHelper'
import chainUtils from 'service/chainUtils'
import { getRewards } from 'service/service'
import { useRouter } from 'next/router'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { CommitButton } from 'components/CommitButton'
import QuestionHelper from 'components/QuestionHelper'
import { useWallet } from 'hooks/useWallet'
import { calculateGasMargin } from 'utils'
import Bribe from 'config/abi/Bribe.json'
import { useSigner } from 'wagmi'
import { Contract } from '@ethersproject/contracts'
import { getWeeklyRewardDistrbutors } from 'service/service'

const Wrap = styled.div<{ isMobile?: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '100%' : '1100px')};
  margin-bottom: 100px;
  position: relative;
  z-index: 10000;
  .flex-received {
    background: #fafafa;
    border-radius: 4px;
    padding: 15px;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
  }
  /* mobile */
  .box-cls {
  }
`
const TopCont = styled.div`
  width: 100%;
  margin-bottom: 33px;
  // background-color: #fff;
  // padding: 40px 0;
  // border-radius: 30px;
`
const BoxWrap = styled.div`
  display: flex;
  /* padding-top: 40px; */
`
const HalfWrap = styled.div`
  width: calc(50% - 10px);
  // padding: 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  padding: 40px;
  border-radius: 30px;
  &:nth-child(1) {
    margin-right: 20px;
  }
`
const HalfButton = styled(Button)`
  width: 48%;
  font-size: 14px;
  border-color: #dbdbdb;
`
const ReceiveCont = styled.div`
  background: #fafafa;
  border-radius: 10px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  color: #14162a;
  margin: 12px 0 25px;
`
const TableWrap = styled.div`
  /* padding: 30px 0; */
`
const TableHead = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  .headText {
    color: #85868a;
    flex: 1;
    font-size: 12px;
    &:nth-child(1) {
      flex: 0.5;
    }
    &:nth-child(2) {
      flex: 1;
      text-align: right;
    }
    &:nth-child(3) {
      text-align: right;
    }
    &:nth-child(4) {
      text-align: right;
    }
  }
`
const TableCont = styled.div`
  .bodyText {
    flex: 1;
    margin-bottom: 20px;
    &:nth-child(1) {
      flex: 0.5;
    }
    &:nth-child(2) {
      flex: 1;
      text-align: right;
      flex-direction: row-reverse;
    }
    &:nth-child(3) {
      text-align: right;
    }
    &:nth-child(4) {
      text-align: right;
      flex-direction: row-reverse;
    }
  }
  .nodata {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-height: 300px;
  }
  .button-cls {
    background-color: transparent;
    padding: 0 100px;
    border-color: #c1c2c4;
  }
`

export default function Reward() {
  const gasPrice = useGasPrice()
  const { account } = useWeb3React()
  const { isXxxxl } = useMatchBreakpoints()
  const { t } = useTranslation()
  const { isWrongNetwork } = useActiveChainId()
  const { onPresentConnectModal } = useWallet()
  const isMobile = !isXxxxl
  const router = useRouter()
  // const parsedQueryChainId = Number(router.query.chainId)
  // const chainId = parsedQueryChainId
  const [allData, setAllData] = useState<any>({
    lockedData: 0, // 质押数量
    retrieveStatus: 0, // 0 - 未创建 1-已到期 2-进行中
    lockEsNoah: 0, // esnoah解锁数量
    balanceEsNoah: 0, // esnoah余额
    lockTimeEsNoah: 0, // esnoah解锁周期
    collectedEsNoah: 0, // 待领取esnoah数量
    lockedNoah: 0, // 已解锁noah数量
  })
  const [serverData, setServerData] = useState<any>({
    price: 0,
    weekReward: 0,
  })
  const [estiValue, setEstiValue] = useState<any>(0)
  const timerRef = useRef<any>()
  const timerRef1 = useRef<any>()
  const [reset, setReset] = useState<any>(false)
  const votingEscrowContract = useVotingEscrowContract()
  const esnoahContract = useEsnoahContract()
  const rewardsDistributorContract = useRewardsDistributorContract()
  const vesterContract = useVesterContract()
  const voterContract = useVoterContract()
  const MinterContract = useMinterContract()
  const { data: signer } = useSigner()

  // console.log('votingEscrowContract', votingEscrowContract);
  const [{ attemptingTxn, rewardErrorMessage, txHash }, setRewardState] = useState<{
    attemptingTxn: boolean
    rewardErrorMessage: string | undefined
    txHash: string | undefined
  }>({
    attemptingTxn: false,
    rewardErrorMessage: undefined,
    txHash: undefined,
  })
  const [pendingText, setPendingText] = useState('')
  const [tableData, setTableData] = useState<any>([])
  // 领取成功/领取失败
  const [{ successText, failText }, setText] = useState({
    successText: t('noah244'),
    failText: t('noah245'),
  })
  const addTransaction = useTransactionAdder()
  const [onPresentResultModal] = useModal(
    <ResultModal
      pendingText={pendingText}
      hash={txHash}
      attemptingTxn={attemptingTxn}
      errorMessage={rewardErrorMessage}
      successText={successText}
      failText={failText}
      isSuccess={() => {
        console.log('successRewardGetdata')
        // setTimeout(() => {
        //   getData()
        // }, 1000)
      }}
    />,
    false,
    true,
    'ResultModal',
  )
  // 获取详细数据
  const getData = async () => {
    // console.log(JSBI.lessThan(JSBI.BigInt(1), JSBI.BigInt(0)).toString(), '333')
    try {
      if (account) {
        // 解锁上限
        const lockedData = await votingEscrowContract.locked(account)
        const endTimes = await votingEscrowContract.locked_end(account)
        // console.log(endTimes?.toString(), 'endTimes')
        const esnoahBalance = await esnoahContract.balanceOf(account)
        const claimable = await rewardsDistributorContract.claimable(account)
        // console.log(claimable.toString(), 'claimableclaimable')
        // 解锁数量
        const lockEsNoah = await vesterContract.balances(account)
        const claimableAmount = await vesterContract.getNextClaimableAmount(account)
        // console.log(Number(formatBigNumberToFixed(lockEsNoah || 0).toString()), '111')
        // console.log(Number(formatBigNumberToFixed(claimableAmount || 0).toString()), '222')
        // console.log(
        //   Number(formatBigNumberToFixed(lockEsNoah || 0).toString()) -
        //     Number(formatBigNumberToFixed(claimableAmount || 0).toString()),
        //   '3333',
        // )
        // console.log(formatBigNumberToFixed(lockedData.amount || 0).toString(), '444')

        // 解锁周期
        // const lastVestingData = await vesterContract.lastVesting(account)
        const vesting = await votingEscrowContract.vestingTime(account, 0)
        // 已解锁
        const claimabled = (await vesterContract.claimable(account)) || 0

        const userVotes = await voterContract['userVotes(address)'](account) // 批量查询用户投票数据
        // console.log('userVotes', userVotes)

        // userVotes._votes.map((vote, index) => {
        //   console.log('pool', vote, Number(formatBigNumberToFixed(vote || 0)))
        // })
        let allZeros = true
        if (userVotes._votes.length === 0) {
          allZeros = false
        } else {
          allZeros = userVotes._votes.every((item) => Number(formatBigNumberToFixed(item)) === 0)
        }

        if (allZeros) {
          // console.log("每一项都为 0");
          setReset(true)
        } else {
          // console.log("某一项不为 0");
          setReset(false)
        }

        if (Number(endTimes?.toString()) === 0) {
          setAllData({
            ...allData,
            lockedData: formatBigNumberToFixed(lockedData.amount || 0).toString(), // 质押数量
            lockEsNoah: (
              Number(formatBigNumberToFixed(lockEsNoah || 0).toString()) -
              Number(formatBigNumberToFixed(claimableAmount || 0).toString())
            ).toString(), // esnoah解锁数量
            balanceEsNoah: formatFixedNumber(esnoahBalance || 0, 15).toString(), // esnoah余额
            collectedEsNoah: formatBigNumberToFixed(claimable || 0).toString(), // 待领取esnoah数量
            lockedNoah: formatBigNumberToFixed(claimabled || 0).toString(), // 已解锁数量
            retrieveStatus: 0,
          })
        } else if (Number(endTimes?.toString()) < new Date().getTime() / 1000) {
          setAllData({
            ...allData,
            lockedData: formatBigNumberToFixed(lockedData.amount || 0).toString(), // 质押数量
            lockEsNoah: (
              Number(formatBigNumberToFixed(lockEsNoah || 0).toString()) -
              Number(formatBigNumberToFixed(claimableAmount || 0).toString())
            ).toString(), // esnoah解锁数量
            balanceEsNoah: formatFixedNumber(esnoahBalance || 0, 15).toString(), // esnoah余额
            collectedEsNoah: formatBigNumberToFixed(claimable || 0).toString(), // 待领取esnoah数量
            lockedNoah: formatBigNumberToFixed(claimabled || 0).toString(), // 已解锁数量
            retrieveStatus: 1,
          })
        } else {
          setAllData({
            ...allData,
            lockedData: formatBigNumberToFixed(lockedData.amount || 0).toString(), // 质押数量
            lockEsNoah: (
              Number(formatBigNumberToFixed(lockEsNoah || 0).toString()) -
              Number(formatBigNumberToFixed(claimableAmount || 0).toString())
            ).toString(), // esnoah解锁数量
            balanceEsNoah: formatFixedNumber(esnoahBalance || 0, 15).toString(), // esnoah余额
            collectedEsNoah: formatBigNumberToFixed(claimable || 0).toString(), // 待领取esnoah数量
            lockedNoah: formatBigNumberToFixed(claimabled || 0).toString(), // 已解锁数量
            lockTimeEsNoah: (vesting.toString() / 604800).toFixed(1),
            retrieveStatus: 2,
          })
        }
        // console.log(allData, 'allData')
      }
    } catch (error) {
      // console.log()
    }
  }
  useEffect(() => {
    if (!account) {
      setAllData({
        lockedData: 0, // 质押数量
        retrieveStatus: 0, // 0 - 未创建 1-已到期 2-进行中
        lockEsNoah: 0, // esnoah解锁数量
        balanceEsNoah: 0, // esnoah余额
        lockTimeEsNoah: 0, // esnoah解锁周期
        collectedEsNoah: 0, // 待领取esnoah数量
        lockedNoah: 0, // 已解锁noah数量
      })
    }
    if (
      !account &&
      !votingEscrowContract &&
      !esnoahContract &&
      !rewardsDistributorContract &&
      !vesterContract &&
      !voterContract
    )
      return
    getData()
    timerRef.current = setInterval(() => {
      getData()
    }, 6000)
    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(timerRef.current)
    }
  }, [account, votingEscrowContract, esnoahContract, rewardsDistributorContract, vesterContract, voterContract])
  // 接口获取投票奖励数据
  const fetch = async () => {
    const { baseURL, chainid } = chainUtils()
    const { data, code } = await getRewards({ baseURL, chainid, account })
    if (code === 0) {
      try {
        const datas = data?.map((v) => v[Object.keys(v)[0]]) || []
        const contractParams = datas.map((v) => v?.bribe) || []
        const { tokens, claimables } = await voterContract.earnedBribes(contractParams, account)
        // console.log(tokens, 'tokens')
        // console.log(claimables, 'claimables')
        // console.log(JSBI.BigInt('272.12'), '123144')
        const dataFormat = datas
          .map((item, i) => {
            // console.log(JSBI.BigInt(new BigNumber(item.bribeList[0].usdPrice)), '123144')
            return {
              ...item,
              tokenListValue: claimables[i].reduce((total, currentValue, currentIndex) => {
                if (currentIndex > 0) {
                  return total + Number(formatBigNumberToFixed(currentValue || 0).toString())
                }
                return 0
              }, 0),
              feeValue: formatBigNumberToFixed(claimables[i][0] || 0, item.bribeList[0].decimal).toString(),
              feeUsd:
                formatBigNumberToFixed(claimables[i][0] || 0, item.bribeList[0].decimal).toString() *
                item.bribeList[0]?.usdPrice,
              bribeList: item.bribeList
                .slice(1)
                .map((element, j) => {
                  return {
                    ...element,
                    coinBalance: formatBigNumberToFixed(claimables[i][j + 1] || 0, element.decimal).toString(),
                  }
                })
                .filter((v) => {
                  return v.coinBalance > 0
                }),
            }
          })
          .filter((v) => {
            return Number(v.feeValue) + Number(v.tokenListValue) > 0
          })
        // console.log(dataFormat, 'dataFormat')
        setTableData(dataFormat)
      } catch (error) {
        console.log(error, 'error')
      }
    }
  }
  useEffect(() => {
    if (!account || !voterContract) return
    fetch()
    timerRef1.current = setInterval(() => {
      fetch()
    }, 10000)
    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(timerRef1.current)
    }
  }, [account, voterContract])

  // 领取esnoah type - 1：领取esnoah 2：领取noah 3-领取全部 4-领取单个池子
  const handleReceiveEsNoah = async (type, item?: any) => {
    let method: any
    let args: any
    let estimate
    if (type === 1) {
      estimate = rewardsDistributorContract.estimateGas.claim
      method = rewardsDistributorContract.claim
      args = [account]
      // 领取质押奖励
      setPendingText(`${t('noah416')} ${allData.collectedEsNoah} esNOAH`)
    } else if (type === 2) {
      estimate = vesterContract.estimateGas.claim
      method = vesterContract.claim
      args = []
      // 领取已解锁
      setPendingText(`${t('noah417')} ${allData.lockedNoah} NOAH`)
    } else if (type === 3) {
      // console.log('reset', reset)
      const promise1 = new Promise((resolve) => {
        estimate = voterContract.estimateGas.reset
        method = voterContract.reset
        args = []
        if (reset) {
          setPendingText(t('noah418'))
          handleMultiple(estimate, method, args)
        }
      })
      const promise2 = new Promise((resolve) => {
        estimate = voterContract.estimateGas.claimBribes
        method = voterContract.claimBribes
        // console.log(tableData, 'tableData')
        const args1 = tableData
          .filter((v) => {
            return Number(v.feeValue) + Number(v.tokenListValue) > 0
          })
          .map((vv) => vv.bribe)
        // 列表是否有奖励
        const isValue = tableData.reduce((total, currentValue) => {
          return total + Number(currentValue.feeValue) + Number(currentValue.tokenListValue)
        }, 0)
        // console.log(isValue, 'isValue')
        const args2 = isValue
          ? tableData.map((v) => {
              if (Number(v.feeValue) > 0 && Number(v.tokenListValue) === 0) {
                return [v.pair_id]
              }
              if (Number(v.feeValue) === 0 && Number(v.tokenListValue) > 0) {
                return [...v.bribeList.map((vv) => vv.contract)]
              }
              if (Number(v.feeValue) > 0 && Number(v.tokenListValue) > 0) {
                return [v.pair_id, ...v.bribeList.map((vv) => vv.contract)]
              }
            })
          : []
        // console.log(args1, 'args1')
        // console.log(args2, 'args2')
        args = [args1, args2]
        // 领取投票奖励
        setPendingText(t('noah418'))
        handleMultiple(estimate, method, args)
      })
      return
    } else {
      // console.log('领取单个')
      // console.log('reset', reset)
      const promise1 = new Promise((resolve) => {
        estimate = voterContract.estimateGas.reset
        method = voterContract.reset
        args = []
        if (reset) {
          setPendingText(t('noah418'))
          handleMultiple(estimate, method, args)
        }
      })
      const promise2 = new Promise((resolve) => {
        const BribeOtherContract = new Contract(item?.bribe, Bribe, signer)
        console.log(BribeOtherContract, 'BribeOtherContract')
        // console.log(item, 'item')
        estimate = BribeOtherContract.estimateGas.getReward
        method = BribeOtherContract.getReward
        // 列表是否有奖励
        let args1 = []
        if (Number(item.feeValue) > 0 && Number(item.tokenListValue) === 0) {
          args1 = [item.pair_id]
        }
        if (Number(item.feeValue) === 0 && Number(item.tokenListValue) > 0) {
          args1 = [...item.bribeList.map((vv) => vv.contract)]
        }
        // if (Number(item.feeValue) > 0 && Number(item.tokenListValue) > 0) {
        args1 = [item.pair_id, ...item.bribeList.map((vv) => vv.contract)]
        // }
        // console.log(args1, 'args1')
        args = [account, args1]
        // 领取投票奖励
        setPendingText(t('noah418'))
        handleMultiple(estimate, method, args)
      })
      return
    }
    onPresentResultModal()
    // 领取成功/领取失败
    setText({
      successText: t('noah244'),
      failText: t('noah245'),
    })
    setRewardState({ attemptingTxn: true, rewardErrorMessage: undefined, txHash: undefined })
    await estimate(...args)
      .then((estimatedGasLimit) =>
        method(...args, {
          gasLimit: calculateGasMargin(estimatedGasLimit),
          gasPrice,
        }).then((response) => {
          // console.log(response, 'responseresponse')
          setRewardState({ attemptingTxn: false, rewardErrorMessage: undefined, txHash: response.hash })
          addTransaction(response, {
            summary: 'reward NOAH',
            translatableSummary: {
              text:
                type === 1
                  ? `${t('noah416')} ${allData.collectedEsNoah} esNOAH`
                  : type === 2
                  ? `${t('noah417')} ${allData.lockedNoah} NOAH`
                  : t('noah418'),
              data: {},
            },
            type: 'reward',
          })
        }),
      )
      .catch((err) => {
        console.log(err, 'err')
        if (err && err.code !== 4001) {
          console.error(`Reward failed`, err)
          setRewardState({
            attemptingTxn: false,
            rewardErrorMessage: err.message,
            txHash: undefined,
          })
        }
        setRewardState({
          attemptingTxn: false,
          rewardErrorMessage:
            err && err.code !== 4001
              ? t('Reward failed: %message%', { message: transactionErrorToUserReadableMessage(err, t) })
              : undefined,
          txHash: undefined,
        })
      })
  }

  const handleMultiple = async (estimate, method, args) => {
    onPresentResultModal()
    // 领取成功/领取失败
    setText({
      successText: t('noah244'),
      failText: t('noah245'),
    })
    setRewardState({ attemptingTxn: true, rewardErrorMessage: undefined, txHash: undefined })
    await estimate(...args)
      .then((estimatedGasLimit) =>
        method(...args, {
          gasLimit: calculateGasMargin(estimatedGasLimit),
          gasPrice,
        }).then((response) => {
          // console.log(response, 'responseresponse')
          setRewardState({ attemptingTxn: false, rewardErrorMessage: undefined, txHash: response.hash })
          addTransaction(response, {
            summary: 'reward NOAH',
            translatableSummary: {
              text: t('noah418'),
              data: {},
            },
            type: 'reward',
          })
        }),
      )
      .catch((err) => {
        console.log(err, 'err')
        if (err && err.code !== 4001) {
          console.error(`Reward failed`, err)
          setRewardState({
            attemptingTxn: false,
            rewardErrorMessage: err.message,
            txHash: undefined,
          })
        }
        setRewardState({
          attemptingTxn: false,
          rewardErrorMessage:
            err && err.code !== 4001
              ? t('Reward failed: %message%', { message: transactionErrorToUserReadableMessage(err, t) })
              : undefined,
          txHash: undefined,
        })
      })
  }
  // 增加减少解锁 0-增加 1-减少
  const handleSubmit = async (type: any, debounceNumInput: any) => {
    let method: any
    let args: any
    let estimate
    if (!type) {
      estimate = vesterContract.estimateGas.deposit
      method = vesterContract.deposit
      args = [parseUnits(debounceNumInput, 18).toString()]
      setPendingText(
        t('Add %num% esNOAH to unlock', {
          num: Number(allData.lockEsNoah) + Number(debounceNumInput),
        }),
      )
    } else {
      estimate = vesterContract.estimateGas.withdraw
      method = vesterContract.withdraw
      args = [Math.floor((Number(debounceNumInput) / Number(allData.lockEsNoah)) * 1000)]
      setPendingText(
        t('Decrease %num% esNOAH to unlock', {
          num: Number(debounceNumInput),
        }),
      )
    }
    // return
    // 操作成功 / 操作失败
    setText({
      successText: t('noah389'),
      failText: t('noah390'),
    })
    onPresentResultModal()
    setRewardState({ attemptingTxn: true, rewardErrorMessage: undefined, txHash: undefined })
    await estimate(...args)
      .then((estimatedGasLimit) =>
        method(...args, {
          gasLimit: calculateGasMargin(estimatedGasLimit),
          gasPrice,
        }).then((response) => {
          console.log(response, 'responseresponse')
          setRewardState({ attemptingTxn: false, rewardErrorMessage: undefined, txHash: response.hash })
          addTransaction(response, {
            summary: 'locked NOAH',
            translatableSummary: {
              text: !type
                ? t('Add %num% esNOAH to unlock', { num: Number(allData.lockEsNoah) + Number(debounceNumInput) })
                : t('Decrease %num% esNOAH to unlock', { num: Number(debounceNumInput) }),
              data: {},
            },
            type: 'locked',
          })
        }),
      )
      .catch((err) => {
        console.log(err, 'err')
        if (err && err.code !== 4001) {
          console.error(`locked failed`, err)
          setRewardState({
            attemptingTxn: false,
            rewardErrorMessage: err.message,
            txHash: undefined,
          })
        }
        setRewardState({
          attemptingTxn: false,
          rewardErrorMessage:
            err && err.code !== 4001
              ? t(' failed: %message%', { message: transactionErrorToUserReadableMessage(err, t) })
              : undefined,
          txHash: undefined,
        })
      })
  }
  const [onPresentLockModal] = useModal(
    <LockModal allData={allData} handleSubmit={handleSubmit} />,
    true,
    true,
    'LockModal',
  )

  // 每纪元奖励的总数量
  useEffect(() => {
    const { baseURL, chainid } = chainUtils()
    const params = {
      pageSize: 1,
    }
    const fetch = async () => {
      const { data, code } = await getWeeklyRewardDistrbutors(params, { baseURL, chainid })
      if (!code) {
        setServerData({
          price: data?.price || 0,
          weekReward: data?.list[0]?.weekly_reward_distributor || 0,
        })
      }
    }
    fetch()
  }, [])

  // console.log('serverData', serverData)

  const getPeriodStart = async () => {
    try {
      const periodStart = await MinterContract.periodStart() // 查询当前所在周期的开始时间
      // 这里加上了1周的时间
      // console.log('periodStart======', periodStart.toString(), Number(periodStart.toString()) + Number(604800))
      // 该结束周期veNOAH总数量
      const totalSupplyAt = await votingEscrowContract.totalSupplyAtT(Number(periodStart.toString()) + Number(604800))
      // console.log('totalSupplyAt', formatBigNumberToFixed(totalSupplyAt || 0))
      // 该结束周期veNOAH总数量---用户
      const accountveNOAH = await votingEscrowContract.balanceOfAtT(
        account,
        Number(periodStart.toString()) + Number(604800),
      )
      // console.log('accountveNOAH', formatBigNumberToFixed(accountveNOAH || 0))

      const accountveNOAHValue = Number(formatFixedNumber(accountveNOAH || 0))
      const totalSupplyAtValue = Number(formatFixedNumber(totalSupplyAt || 0))

      // console.log('最终计算结果', accountveNOAHValue / totalSupplyAtValue * serverData.weekReward)
      // 本纪元预计获得
      setEstiValue((accountveNOAHValue / totalSupplyAtValue) * serverData.weekReward)
      // console.log('EstiValue', estiValue)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    // if (serverData.weekReward && account && !MinterContract && !votingEscrowContract) return
    if (serverData.weekReward && account && MinterContract && votingEscrowContract) {
      getPeriodStart()
    }
  }, [serverData.weekReward, account, MinterContract, votingEscrowContract])

  return (
    <Page footer={false} style={{ paddingTop: !isMobile ? '0' : '' }} isMobile={isMobile}>
      {!isMobile ? (
        <Wrap isMobile={isMobile}>
          <div style={{ display: 'flex' }}>
            <div style={{ width: 'calc(50% - 10px)', marginRight: '20px' }}>
              <Text fontSize="24px" fontWeight="600" mb="5px">
                {t('noah544')}
              </Text>
              <Text fontSize="14px" mb="15px">
                {t('noah545')}
              </Text>
            </div>
            <div style={{ width: 'calc(50% - 10px)' }}>
              <Text fontSize="24px" fontWeight="600" mb="5px">
                {t('noah309')}
              </Text>
              {/* 质押NOAH获得esNOAH奖励。 */}
              <Text fontSize="14px" mb="15px">
                {t('noah310')}
              </Text>
            </div>
          </div>
          <TopCont>
            <BoxWrap>
              <HalfWrap>
                <Box>
                  <Flex justifyContent="space-between" mb="18px">
                    {/* 解锁数量 */}
                    <Text color="#85868A" small>
                      {t('noah313')}
                    </Text>
                    <Text small>{getRes(allData?.lockEsNoah, 4) || '0.0000'} esNOAH</Text>
                  </Flex>
                  <Flex justifyContent="space-between">
                    <Flex justifyContent="center" alignItems="center">
                      {/* 解锁状态 */}
                      <Text color="#85868A" mr="10px" small>
                        {t('noah438')}
                      </Text>
                      {/* <BonusHelper
                        placement="top-start"
                        ml="0"
                        text={
                          <Box>
                            <Text mb="3px">{t('noah395')}</Text>
                            <Text mb="3px">{t('noah396')}</Text>
                            <Text mb="3px">{t('noah397')}</Text>
                            <Text mb="3px">{t('noah398')}</Text>
                            <Text mb="3px">{t('noah399')}</Text>
                          </Box>
                        }
                      /> */}
                    </Flex>
                    {/* 365天/停止解锁/未解锁 */}
                    {Number(allData.lockEsNoah) === 0 ? (
                      // 未解锁
                      <Text small>{t('noah317')}</Text>
                    ) : Number(allData.lockEsNoah) > 0 && Number(allData?.lockedData) === 0 ? (
                      // 停止解锁
                      <Text small>{t('noah316')}</Text>
                    ) : (
                      // 解锁中
                      <Text small>{t('noah439')}</Text>
                    )}
                  </Flex>
                  {/* 领取 */}
                  {/* 已解锁 */}
                  {allData.lockedNoah > 0 ? (
                    <ReceiveCont>
                      <Text small>
                        {t('noah318')} {getRes(allData.lockedNoah, 4) || '0.0000'} NOAH
                      </Text>
                      <Text
                        color="#F0B000"
                        style={{ cursor: 'pointer' }}
                        bold
                        small
                        onClick={() => {
                          if (!account) {
                            onPresentConnectModal()
                            return
                          }
                          handleReceiveEsNoah(2)
                        }}
                      >
                        {t('noah237')}
                      </Text>
                    </ReceiveCont>
                  ) : (
                    <></>
                  )}
                </Box>
                <Flex justifyContent="space-between">
                  {/* 解锁esNOAH */}
                  {isWrongNetwork ? (
                    <CommitButton />
                  ) : (
                    <HalfButton
                      style={{ background: 'transparent', width: '100%' }}
                      onClick={() => {
                        if (!account) {
                          onPresentConnectModal()
                          return
                        }
                        onPresentLockModal()
                      }}
                    >
                      {t('noah321')}
                    </HalfButton>
                  )}
                </Flex>
              </HalfWrap>
              <HalfWrap>
                <Flex justifyContent="space-between" mb="18px">
                  <Text color="#85868A" small style={{ display: 'flex', alignItems: 'center' }}>
                    {t('noah542')}
                    &nbsp;
                    <QuestionHelper
                      type="info"
                      text={t('noah543')}
                      placement="top-start"
                      ml="0"
                      style={{ position: 'relative', top: '-1px' }}
                    />
                  </Text>
                  <Text small>{getRes(estiValue, 4) || '0.0000'} esNOAH</Text>
                </Flex>
                <Flex justifyContent="space-between" mb="18px">
                  <Text color="#85868A" small style={{ display: 'flex', alignItems: 'center' }}>
                    {t('noah589')}
                    &nbsp;
                    <QuestionHelper
                      type="info"
                      text={t('noah584')}
                      placement="top-start"
                      ml="0"
                      style={{ position: 'relative', top: '-1px' }}
                    />
                  </Text>
                  <Text small>
                    {Number(allData?.lockedData) > 0 ? (
                      <span>
                        {Number(truncateZero(((estiValue * 52) / Number(allData?.lockedData)) * 100, 2)) < 0.01
                          ? '< 0.01'
                          : truncateZero(((estiValue * 52) / Number(allData?.lockedData)) * 100, 2)}
                        %
                      </span>
                    ) : (
                      <span>0.00%</span>
                    )}
                  </Text>
                </Flex>
                {/* 待领取 */}
                <Flex justifyContent="space-between" mb="18px">
                  <Text color="#85868A" small>
                    {t('noah311')}
                  </Text>
                  <Text small>{getRes(allData?.collectedEsNoah, 4) || '0.0000'} esNOAH</Text>
                </Flex>
                {/* 余额 */}
                {/* <Flex justifyContent="space-between">
                  <Text color="#85868A" small>
                    {t('noah546')}
                  </Text>
                  <Text small>{getRes(allData?.balanceEsNoah, 4) || '0.0000'} esNOAH</Text>
                </Flex> */}
                <Flex justifyContent="space-between" mt={allData.lockedNoah > 0 ? '100px' : '50px'}>
                  {/* 转移esNOAH */}
                  {/* <HalfButton
                    style={{ background: 'transparent' }}
                    onClick={() => {
                      onPresentTransferModal()
                    }}
                  >
                    {t('noah319')}
                  </HalfButton> */}
                  {/* 领取esNOAH */}
                  <HalfButton
                    style={{ borderColor: !Number(allData?.collectedEsNoah) ? '#fff' : '#000', width: '100%' }}
                    disabled={!Number(allData?.collectedEsNoah)}
                    onClick={() => {
                      if (!account) {
                        onPresentConnectModal()
                        return
                      }
                      handleReceiveEsNoah(1)
                    }}
                  >
                    {t('noah320')}
                  </HalfButton>
                </Flex>
              </HalfWrap>
            </BoxWrap>
          </TopCont>
          <Flex justifyContent="space-between">
            <Box>
              {/* 投票奖励 */}
              <Text fontSize="24px" fontWeight="600" mb="5px">
                {t('noah322')}
              </Text>
              <Text fontSize="14px" mb="15px">
                {t('noah323')}
              </Text>
            </Box>
            {/* 领取全部 */}
            {account ? (
              <Button
                style={{ height: '40px', fontSize: '14px' }}
                disabled={tableData.every((v: any) => Number(v.feeValue) + Number(v.tokenListValue) === 0)}
                onClick={() => {
                  handleReceiveEsNoah(3)
                }}
              >
                {t('noah401')}
              </Button>
            ) : (
              <></>
            )}
          </Flex>
          <TopCont style={{ padding: '40px', backgroundColor: '#fff', borderRadius: '30px' }}>
            <TableWrap>
              <TableHead>
                {/* 流动池 */}
                <Text className="headText">{t('noah286')}</Text>
                {/* 手续费分成 */}
                <Text className="headText">{t('noah324')}</Text>
                {/* 贿赂奖励 */}
                <Text className="headText">{t('noah325')}</Text>
                {/* 操作 */}
                <Text className="headText">{t('noah291')}</Text>
              </TableHead>
              <TableCont>
                {tableData.length > 0 ? (
                  tableData?.map((poolData: any, index: any) => {
                    const symbolChange = {
                      token0: {
                        name: poolData.name0,
                        symbol: poolData.symbol0,
                        address: poolData.contract0,
                      },
                      token1: {
                        name: poolData.name1,
                        symbol: poolData.symbol1,
                        address: poolData.contract1,
                      },
                    }
                    return (
                      <Flex key={index} mb="10px">
                        <Flex alignItems="center" className="bodyText">
                          <DoubleCurrencyLogo token0={symbolChange.token0} token1={symbolChange.token1} size={30} />
                          <Flex style={{ marginLeft: '30px' }}>
                            <Text small>{symbolChange?.token0?.symbol}</Text>
                            <Text small>/{symbolChange?.token1?.symbol}</Text>
                          </Flex>
                        </Flex>
                        <Flex className="bodyText" alignItems="center">
                          {/* <Text small>$ {poolData?.feeUsd}</Text> */}
                          {poolData?.feeUsd > 0.01 ? (
                            <Text small>$ {truncateZero(poolData?.feeUsd, 2)}</Text>
                          ) : poolData?.feeUsd == 0 ? (
                            <Text small>$ 0.00</Text>
                          ) : (
                            <Text small>$ &lt; 0.01</Text>
                          )}
                        </Flex>
                        <Flex className="bodyText" alignContent="center" justifyContent="center" flexDirection="column">
                          {poolData?.bribeList.length > 0 ? (
                            poolData?.bribeList?.map((v: any, i: any) => {
                              return v.type === 2 ? (
                                <Text small key={i}>
                                  {getRes(v?.coinBalance, 4)} {v.symbol}
                                </Text>
                              ) : (
                                <></>
                              )
                            })
                          ) : (
                            <Text small>0</Text>
                          )}
                        </Flex>
                        {/* 领取 */}
                        <Flex
                          className="bodyText"
                          alignItems="center"
                          onClick={() => {
                            handleReceiveEsNoah(4, poolData)
                          }}
                        >
                          <Text fontSize="16px" style={{ cursor: 'pointer' }}>
                            {t('noah237')}
                          </Text>
                        </Flex>
                      </Flex>
                    )
                  })
                ) : (
                  <div className="nodata">
                    <img src="/images/claim/nodata.png" alt="" style={{ width: '70px', height: '50px' }} />
                    {/* 您的投票奖励为空 */}
                    <Text fontSize="18px" color="#85868A" mb="20px" mt="12px">
                      {t('noah338')}
                    </Text>
                    {/* 投票表决 */}
                    <NextLink href={'/vote'} passHref>
                      <span>{t('noah339')} &gt;</span>
                      {/* <Button className="button-cls">{t('noah339')}</Button> */}
                    </NextLink>
                  </div>
                )}
              </TableCont>
            </TableWrap>
          </TopCont>
        </Wrap>
      ) : (
        <Wrap isMobile={isMobile}>
          <Box mb="15px">
            <div>
              <div>
                {/* 质押奖励 */}
                <Text fontSize="20px" fontWeight="500" mb="5px">
                  {t('noah544')}
                </Text>
                {/* 质押NOAH获得esNOAH奖励 */}
                <Text small>{t('noah545')}</Text>
              </div>
            </div>
          </Box>
          <TopCont style={{ padding: '30px 20px', backgroundColor: '#fff', borderRadius: '30px' }}>
            <Box className="box-cls">
              <Flex justifyContent="space-between" mb="15px" mt="0px">
                {/* 解锁数量 */}
                <Text color="#85868A" small>
                  {t('noah313')}
                </Text>
                <Text small>{getRes(allData?.lockEsNoah || '0.0000', 4) || '0.0000'} esNOAH</Text>
              </Flex>
              <Flex justifyContent="space-between">
                {/* 解锁状态 */}

                <Flex justifyContent="center" alignItems="center">
                  <Text color="#85868A" mr="10px" small>
                    {t('noah438')}
                  </Text>
                  {/* <BonusHelper
                    placement="top-start"
                    ml="0"
                    text={
                      <Box>
                        <Text mb="3px">{t('noah395')}</Text>
                        <Text mb="3px">{t('noah396')}</Text>
                        <Text mb="3px">{t('noah397')}</Text>
                        <Text mb="3px">{t('noah398')}</Text>
                        <Text mb="3px">{t('noah399')}</Text>
                      </Box>
                    }
                  /> */}
                  {/* <img src="/images/claim/b.png" alt="" style={{ width: '14px', height: '14px' }} /> */}
                </Flex>
                {/* 365天/停止解锁/未解锁 */}
                {Number(allData.lockEsNoah) === 0 ? (
                  // 未解锁
                  <Text small>{t('noah317')}</Text>
                ) : Number(allData.lockEsNoah) > 0 && Number(allData?.lockedData) === 0 ? (
                  // 停止解锁
                  <Text small>{t('noah316')}</Text>
                ) : (
                  // 解锁中
                  <Text small>{t('noah439')}</Text>
                )}
              </Flex>
              {allData.lockedNoah > 0 ? (
                <ReceiveCont style={{ marginBottom: 0 }}>
                  <Text fontSize="13px">
                    {t('noah318')} {getRes(allData?.lockedNoah, 4) || '0.0000'} NOAH
                  </Text>
                  <Text
                    color="#F0B000"
                    fontSize="13px"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      if (!account) {
                        onPresentConnectModal()
                        return
                      }
                      handleReceiveEsNoah(2)
                    }}
                  >
                    {t('noah237')}
                  </Text>
                </ReceiveCont>
              ) : (
                <></>
              )}
              {/* 解锁esNOAH */}
              {isWrongNetwork ? (
                <CommitButton />
              ) : (
                <HalfButton
                  style={{
                    background: 'transparent',
                    fontSize: '14px',
                    height: '42px',
                    width: '100%',
                    marginTop: '24px',
                  }}
                  onClick={() => {
                    if (!account) {
                      onPresentConnectModal()
                      return
                    }
                    onPresentLockModal()
                  }}
                >
                  {t('noah321')}
                </HalfButton>
              )}
            </Box>
          </TopCont>

          <Box mb="15px">
            <div>
              <div>
                {/* 质押奖励 */}
                <Text fontSize="20px" fontWeight="500" mb="5px">
                  {t('noah309')}
                </Text>
                {/* 质押NOAH获得esNOAH奖励 */}
                <Text small>{t('noah310')}</Text>
              </div>
            </div>
          </Box>
          <TopCont style={{ padding: '30px 20px', backgroundColor: '#fff', borderRadius: '30px' }}>
            <Box className="box-cls">
              <Flex justifyContent="space-between" mb="15px">
                {/* 待领取 */}
                <Text color="#85868A" small>
                  {t('noah542')}
                </Text>
                <Text small>{getRes(estiValue, 4) || '0.0000'} esNOAH</Text>
              </Flex>
              <Flex justifyContent="space-between" mb="18px">
                <Text color="#85868A" small>
                  {t('noah589')}
                </Text>
                {Number(allData?.lockedData) > 0 ? (
                  <span>
                    {Number(truncateZero(((estiValue * 52) / Number(allData?.lockedData)) * 100, 2)) < 0.01
                      ? '< 0.01'
                      : truncateZero(((estiValue * 52) / Number(allData?.lockedData)) * 100, 2)}
                    %
                  </span>
                ) : (
                  <span>0.00%</span>
                )}
              </Flex>
              <Flex justifyContent="space-between" mb="15px">
                {/* 待领取 */}
                <Text color="#85868A" small>
                  {t('noah311')}
                </Text>
                <Text small>{getRes(allData?.collectedEsNoah || '0.0000', 4) || '0.0000'} esNOAH</Text>
              </Flex>
              {/* <Flex justifyContent="space-between">
                <Text small color="#85868A">
                  {t('noah546')}
                </Text>
                <Text small>{getRes(allData?.balanceEsNoah || '0.0000', 4) || '0.0000'} esNOAH</Text>
              </Flex> */}
              <Flex justifyContent="space-between" mt="24px">
                {/* 转移esNOAH */}
                {/* <HalfButton
                  style={{ background: 'transparent', fontSize: '14px', height: '42px' }}
                  onClick={() => {
                    onPresentTransferModal()
                  }}
                >
                  {t('noah319')}
                </HalfButton> */}
                {/* 领取esNOAH */}
                <HalfButton
                  disabled={!Number(allData?.collectedEsNoah)}
                  style={{
                    fontSize: '14px',
                    height: '42px',
                    borderColor: !Number(allData?.collectedEsNoah) ? '#fff' : '#000',
                    width: '100%',
                  }}
                  onClick={() => {
                    if (!account) {
                      onPresentConnectModal()
                      return
                    }
                    handleReceiveEsNoah(1)
                  }}
                >
                  {t('noah320')}
                </HalfButton>
              </Flex>
            </Box>
          </TopCont>

          <Flex justifyContent="space-between" mb="15px">
            <Box style={{ width: '65%' }}>
              {/* 投票奖励 */}
              <Text fontSize="18px" fontWeight="500" mb="5px">
                {t('noah322')}
              </Text>
              <Text fontSize="12px">{t('noah323')}</Text>
            </Box>
            {/* 领取全部 */}
            {account ? (
              <Button
                style={{ height: '40px', fontSize: '14px' }}
                disabled={tableData.every((v: any) => Number(v.feeValue) + Number(v.tokenListValue) === 0)}
                onClick={() => {
                  handleReceiveEsNoah(3)
                }}
              >
                {t('noah401')}
              </Button>
            ) : (
              <></>
            )}
          </Flex>
          <TopCont style={{ padding: '30px 20px', backgroundColor: '#fff', borderRadius: '30px' }}>
            {tableData.length > 0 ? (
              tableData?.map((poolData: any, index: any) => {
                const symbolChange = {
                  token0: {
                    name: poolData.name0,
                    symbol: poolData.symbol0,
                    address: poolData.contract0,
                  },
                  token1: {
                    name: poolData.name1,
                    symbol: poolData.symbol1,
                    address: poolData.contract1,
                  },
                }
                return (
                  <Box
                    key={index}
                    style={{
                      borderBottom: index === tableData.length - 1 ? '0px solid #DBDBDB' : '1px solid #eee',
                      marginBottom: index === tableData.length - 1 ? '0px' : '20px',
                    }}
                  >
                    <Flex alignItems="center">
                      <DoubleCurrencyLogo token0={symbolChange.token0} token1={symbolChange.token1} size={30} />
                      <Flex style={{ marginLeft: '30px' }}>
                        <Text>{symbolChange?.token0?.symbol}</Text>
                        <Text>/{symbolChange?.token1?.symbol}</Text>
                      </Flex>
                    </Flex>
                    <Flex justifyContent="space-between" mb="15px" mt="15px">
                      {/* 手续费分成 */}
                      <Text color="#85868A" small>
                        {t('noah324')}
                      </Text>
                      {poolData?.feeUsd > 0.01 ? (
                        <Text small>$ {truncateZero(poolData?.feeUsd, 2)}</Text>
                      ) : poolData?.feeUsd == 0 ? (
                        <Text small>$ 0.00</Text>
                      ) : (
                        <Text small>$ &lt; 0.01</Text>
                      )}
                    </Flex>
                    <Flex justifyContent="space-between" mb="15px">
                      {/* 贿赂奖励 */}
                      <Text color="#85868A" small>
                        {t('noah325')}
                      </Text>
                      <Box>
                        {poolData?.bribeList.length > 0 ? (
                          poolData?.bribeList?.map((v: any, i: any) => {
                            return (
                              <Text small key={i}>
                                {getRes(v?.coinBalance, 4)} {v.symbol}
                              </Text>
                            )
                          })
                        ) : (
                          <Text small>0</Text>
                        )}
                      </Box>
                    </Flex>
                    <Button
                      style={{
                        width: '100%',
                        height: '36px',
                        fontSize: '14px',
                        backgroundColor: 'transparent',
                        borderColor: '#c1c2c4',
                      }}
                      onClick={() => {
                        handleReceiveEsNoah(4, poolData)
                      }}
                    >
                      {t('noah237')}
                    </Button>
                  </Box>
                )
              })
            ) : (
              <Flex className="nodata" justifyContent="center" alignItems="center" flexDirection="column">
                <img src="/images/claim/nodata.png" alt="" style={{ width: '50px', height: '50px' }} />
                {/* 您的投票奖励为空 */}
                <Text fontSize="14px" color="#85868A" mb="20px" mt="12px">
                  {t('noah338')}
                </Text>
                {/* 投票表决 */}
                <NextLink href={'/vote'} passHref>
                  {/* <Button
                    style={{
                      height: '36px',
                      fontSize: '14px',
                      backgroundColor: 'transparent',
                      borderColor: '#c1c2c4',
                    }}
                  >
                    {t('noah339')}
                  </Button> */}
                  <span>{t('noah339')} &gt;</span>
                </NextLink>
              </Flex>
            )}
          </TopCont>
        </Wrap>
      )}
    </Page>
  )
}
